import { useState, useReducer } from 'react'

function Greeting () {
  const [message, setMessage] = useState('')
  const [state, setState] = useReducer((s, a) => ({...s, ...a}), {
    resolved: false,
    loading: false,
    error: null,
  })

  function handleSubmit (event) {
    event.preventDefault()
    const {usernameInput} = event.target.elements

    setState({loading: true, resolved: false, error: null})

    window
      .fetch('/.netlify/functions/hello', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          username: usernameInput.value
        })
      })
      .then(r => r.json().then(data => (r.ok ? data : Promise.reject(data))))
      .then(
        user => {
          setState({loading: false, resolved: true, error: null})
          setMessage(user.message)
        },
        error => {
          setState({loading: false, resolved: false, error: error.message})
        },
      )
  }

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="usernameInput">Username</label>
          <input id="usernameInput" />
        </div>
        <button type="submit">Submit{state.loading ? '...' : null}</button>
      </form>
      {state.error ? <div role="alert">{state.error}</div> : null}
      {state.resolved ? (
        <div role="alert">{message}</div>
      ) : null}
    </div>
  )
}

export default Greeting
